export const FLAG_GETTING_MANUAL_VOUCHERS = 'FLAG_GETTING_MANUAL_VOUCHERS';
export const GET_MANUAL_VOUCHERS = 'GET_MANUAL_VOUCHERS';
export const CLEAR_MANUAL_VOUCHERS = 'CLEAR_MANUAL_VOUCHERS';
export const FLAG_MANUAL_VOUCHER_ACTIVITY = 'FLAG_MANUAL_VOUCHER_ACTIVITY';
export const GET_MANUAL_VOUCHER = 'GET_MANUAL_VOUCHER';
export const CLEAR_MANUAL_VOUCHER = 'CLEAR_MANUAL_VOUCHER';
export const FLAG_ORIGINAL_VOUCHER_ACTIVITY = 'FLAG_ORIGINAL_VOUCHER_ACTIVITY';
export const GET_ORIGINAL_VOUCHER = 'GET_ORIGINAL_VOUCHER';
export const CLEAR_ORIGINAL_VOUCHER = 'CLEAR_ORIGINAL_VOUCHER';
